import { t } from "@lingui/core/macro";
import { Outlet, useNavigation, useRevalidator } from "react-router";
import FakeProgress from "fake-progress";
import { useEffect, useMemo, useState } from "react";

export function ProgressBar() {
  const p = useMemo(() => new FakeProgress({ timeConstant: 1000, autoStart: true }), []);
  const [val, setVal] = useState(0);

  useEffect(() => {
    const i = setInterval(() => {
      setVal(p.progress);
    }, 50);
    return () => clearInterval(i);
  }, [p]);

  return (
    <progress
      className="fixed inset-x-0 top-0 z-50 h-0.5 w-screen bg-transparent [&::-webkit-progress-bar]:bg-transparent [&::-webkit-progress-value]:bg-aqua-500 [&::-moz-progress-bar]:bg-aqua-500"
      value={val}
      max={1}
      role="status"
      aria-label={t`Loading`}
    />
  );
}

export function GlobalLoading() {
  const navigation = useNavigation();
  const { state: revalidatorState } = useRevalidator();

  return (
    <>
      {(revalidatorState === "loading" || navigation.state === "loading") && <ProgressBar />}
      <Outlet />
    </>
  );
}
